import React, { useState, useMemo, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export const ImmobilierMenu = ({immoItem, onChangeItem, address, failed}) => {
    const [surface, setSurface] = useState(immoItem.surface);
    const [typeHabitat, setTypeHabitat] = useState(immoItem.typeHabitat.toLowerCase());
    const [pricesEvol, setPricesEvol] = useState(undefined);
    const [pricesEvols, setPricesEvols] = useState(undefined);
    const [chartData, setChartData] = useState(undefined);
    const [isOpen, setIsOpen] = useState(false);

    const formatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0})
    const colors = immoItem && immoItem.codeInsee !== '75056'
        ? ["#EBED8C", "#EADA4A", "#E3B130", "#FF0000", "#8E0000"]
        : ["#EAEC83", "#DBDB04", "#FFCE03", "#FD9A01", "#D94500", "#FF2C05", "#F00505", "#980404", "#590303", "#230000"];

    // chartData Utils
    const calculForEvol = (index) => 1 + pricesEvol[`evol_${index}_a`]
    const options = {
        responsive: true,
        interaction: {
            mode: 'nearest',
            intersect: false,
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                displayColors: false,
                backgroundColor: '#ffffff',
                titleColor: '#979797',
                bodyColor: '#3f3d56',
                bodyFont: {
                    weight: 'bold'
                },
                callbacks: {
                    label: (item) => item.raw.tip
                },
                filter: (item) => item.raw.tip !== null
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                grid: {
                    drawBorder: false,
                    borderDash: [5, 5]
                },
                ticks: {
                    display: false,
                }
            }
        }
    };

    useEffect(() => {
        if(immoItem && immoItem.data){
            if (immoItem.refreshParams) {
                setTypeHabitat(immoItem.typeHabitat.toLowerCase());
                setSurface(immoItem.surface);
            }
            // init evols for chartJS
            const data = immoItem.data;
            let city = data.communes.features.find(com => com.properties.com === immoItem.codeInsee) || undefined
            let irisCity = city ? data.iris.features.find(iris => iris.properties.libelleIris === city.properties.libelle) : undefined
            let irisEstimate = irisCity && data.estimates.find(e => irisCity && e.num_iris === irisCity.properties.codeIris);
            let sortedEvols = data.estimates
                .map(e => e.evolution)
                .reduce((arr, v) => arr.findIndex(e => e.code_postal === v.code_postal) !== -1 ? arr : [...arr, v], [])
                .sort((a,b) => a.code_postal - b.code_postal);
            setPricesEvols(sortedEvols);
            //console.log(sortedEvols);
            if (address && address.cityPostCode) {
                setPricesEvol(sortedEvols.find(evol => evol.code_postal === address.cityPostCode));
            } else if (irisEstimate) {
                setPricesEvol(irisEstimate.evolution);
            } else {
                setPricesEvol(sortedEvols[0]);
            }
        }
    }, [immoItem])

    useEffect(() => {
        if(immoItem && immoItem.data && pricesEvol){
            const year = immoItem.data.year;
            let data = Object.keys(pricesEvol).map((evol, index) => {
                let tip = ((calculForEvol(index + 1) * 100 / calculForEvol(index)) - 100) || ((calculForEvol(1) * 100) - 100)
                let y = calculForEvol(index) ? (calculForEvol(5) * 100 / calculForEvol(index)) : calculForEvol(5)*100

                return index === 5
                    ? { x: (year - index), y: 100, tip: null }
                    : {
                        x: (year - index),
                        y: y,
                        tip: `${tip >= 0 ? '+' : '-'} ${Math.abs(tip).toFixed(1)} %`
                    }
            });

            setChartData({
                labels: Array.from({length: 6}, (_, i) => year - i).reverse() || ['N-5', 'N-4', 'N-3', 'N-2', 'N-1', 'N'],
                datasets: [
                    {
                        label:  "&Eacute;volution des prix depuis 5 ans",
                        data: data.reverse(),
                        borderColor: 'rgba(63, 61, 86, 1)',
                        backgroundColor: 'rgba(63, 61, 86, 1)',
                        pointHoverBorderColor: 'rgba(255, 255, 255, 1)',
                        pointHoverBorderWidth: 2,
                        fill: {
                            target: { value: 100 },
                            above: 'rgba(55, 46, 160, 0.32)',
                            below: 'rgba(255, 46, 160, 0.32)'
                        },
                        parsing: {
                            yAxisKey: 'y'
                        }
                    }
                ]
            })
        }
    }, [pricesEvol])

    const selectCodePostal = (e)=> {
        setPricesEvol(pricesEvols.find(evol => evol.code_postal === e.target.value));
    }

    const refreshEstimate = () => {
        onChangeItem({...immoItem, typeHabitat, surface});
    }

    return (
        <div className={`dashboard-infos ${isOpen ? 'dashboard-infos--open' : ''} `}>
            <div className="block-collapse-edito--main block-collapse-edito bg-white">
                <button class="menu-toggle border-bottom collapsed w-100 d-xl-none" onClick={() => setIsOpen(!isOpen)} title="Menu">
                    <span className="collapse-handler mx-auto rounded-pill border py-0">{isOpen ? 'Voir moins' : 'Voir plus'}</span>
                </button>
                <div className="edito--main-list show">
                    <div class="collapse show px-3 pt-3" >
                        {failed && <p>L'estimateur immobilier n'est pas disponible pour le moment. Veuillez nous excuser pour la gêne occasionnée.</p>}
                        {immoItem &&
                            <>
                                <div className="maif-form my-4 mt-xl-0">
                                    <div className="d-flex flex-wrap justify-content-between">
                                        <div className="form-group-version2 col-12 col-md-6 col-lg-12 col-xl-12 px-0 pr-md-3 pr-lg-0">
                                            <div className="wrapper-label">
                                                <div className="field-label">
                                                    <label htmlFor="typeHabitat">Type de logement</label>
                                                </div>
                                            </div>
                                            <div className="field-item -listbox px-0 col-12">
                                                <select id="typeHabitat" value={typeHabitat} onChange={(e) => setTypeHabitat(e.target.value)}>
                                                    <option value="appartement" selected={typeHabitat === 'appartement'}>Appartement</option>
                                                    <option value="maison" selected={typeHabitat === 'maison'}>Maison</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group-version2 col-12 col-md-6 col-lg-12 col-xl-12 px-0 pl-xl-0">
                                            <div className="wrapper-label">
                                                <div className="field-label">
                                                    <label htmlFor="surface">Surface</label>
                                                </div>
                                            </div>
                                            <div className="field-item -combobox px-0 col-12">
                                                <input className="w-100" id="surface" type="number" step="10" min="0" value={surface} onChange={(e) => setSurface(parseInt(e.target.value))} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" col-12 col-md-6 col-xl-12 px-0 pr-md-3 pr-xl-0">
                                        <button type="button" className="btn btn-primary w-100" id="submitParamaters"  value="Valider" disabled={!surface} onClick={refreshEstimate}>Valider</button>
                                    </div>
                                </div>
                                {immoItem.data &&
                                    <>
                                        <h2><strong>Estimation des prix</strong></h2>
                                        <div className="d-flex justify-content-between mb-4 mt-2">
                                            <div className="d-flex flex-column">
                                                <span className="text-secondary">Basse</span>
                                                <span><strong>{ formatter.format(Math.min(...immoItem.data.estimates.map(e => e.prix_m2))) }/m&sup2;</strong></span>
                                            </div>
                                            <div className="d-flex flex-column">
                                                <span className="text-secondary text-right">Haute</span>
                                                <span><strong>{ formatter.format(Math.max(...immoItem.data.estimates.map(e => e.prix_m2))) }/m&sup2;</strong></span>
                                            </div>
                                        </div>
                                        <div className="estimate-colors-container mt-2">
                                            {colors.map(color => <span className="estimate-color-item" key={color} style={{"--estimate-color": color}}></span>)}
                                        </div>
                                        { pricesEvol && chartData &&
                                            <div className="maif-form my-4">
                                                <h2><strong>&Eacute;volution des prix depuis 5 ans ({pricesEvol.code_postal})</strong></h2>
                                                { pricesEvols.length > 1 &&
                                                    <div className="form-group-version2 col-12 col-md-6 col-xl-12 px-0 pr-md-3 pr-xl-0">
                                                        <div className="wrapper-label my-2">
                                                            <label htmlFor="codePostal" className="help-input">Code postal</label>
                                                        </div>
                                                        <div className="field-item -listbox px-0">
                                                            <select id="codePostal" value={pricesEvol.code_postal} onChange={selectCodePostal}>
                                                                {pricesEvols.map(e => (<option key={e.code_postal} value={e.code_postal}>{e.code_postal}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                }
                                                {chartData && <Line data={chartData} options={options} />}
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        }
                    </div>
                    <div class="alert -primary">
                        <p class="sr-only">Information</p>
                        <i class="maificon maificon-information-round-small" aria-hidden="true"></i>
                        <div class="wrapper-content">
                            <p class="title">Information sur l’estimateur immobilier</p>
                            <div class="content">
                                <p>Nous vous proposons un estimateur immobilier qui s’appuie sur les données ouvertes (open data) DVF Données des Valeurs Foncières
                                issues des actes notariés. Ces données combinées à notre expertise en statistiques / datascience vous permettent de disposer d’un
                                éclairage sur le prix, qui bien sûr ne remplacera pas un avis de valeur réalisé par un expert connaissant parfaitement le marché local.
                                </p>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}